export default {
  type: "object",
  groups: ["year 5", "year 6"],
  category: "pointer",
  target: { type: "pointer", key: "pointer" },
};
